import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PreVenda } from '../models/pre-venda.model';

@Injectable({
  providedIn: 'root'
})
export class PreVendaImportService {
  private preSaleToImport$ = new BehaviorSubject<PreVenda | null>(null);

  setPreSaleToImport(preVenda: PreVenda | null): void {
    this.preSaleToImport$.next(preVenda);
  }

  getPreSaleToImport(): PreVenda | null {
    return this.preSaleToImport$.value;
  }

  consumePreSaleToImport(): PreVenda | null {
    const value = this.preSaleToImport$.value;
    this.preSaleToImport$.next(null);
    return value;
  }
}
